import * as React from "react";
import { ProjectFormPageLayout } from "~/areas/projects/components/ProjectFormPageLayout";
import { GitCallouts } from "~/areas/projects/components/VersionControl/GitCallouts";
import type { FormPaperLayoutProps } from "~/components/FormPaperLayout/FormPaperLayout";
export const ProjectContextFormPaperLayout: React.FC<FormPaperLayoutProps> = ({ children, ...rest }) => (<ProjectFormPageLayout {...rest} callout={<GitCallouts />}>
        {children}
    </ProjectFormPageLayout>);
ProjectContextFormPaperLayout.displayName = "ProjectContextFormPaperLayout"
